export const slugFromCompanyName = (companyName) => companyName
  .toLowerCase()
  .replace('ö', 'oe')
  .replace('ä', 'ae')
  .replace('ü', 'ue')
  .replace('ß', 'ss')
  .replace(/\s/g, '-')
  .replace(/[^a-zA-Z0-9_-]/g, '');
